import React from 'react';

function LoadingIcon({ className = '' }) {
	return (
		<svg
			className={className + ' loader-new__inner'}
			viewBox='0 0 66 66'
			xmlns='http://www.w3.org/2000/svg'
		>
			<circle
				className='loader-new__circle'
				fill='none'
				cx='33'
				cy='33'
				r='30'
			></circle>
		</svg>
	);
}

export default LoadingIcon;
